import * as React from 'react'
import dynamic from 'next/dynamic'

import { useSiteConfig } from '@thg-commerce/enterprise-core'

import { useProductPage } from '../../context'
import { ProofOfImpactIconProps } from '../../components/ProofOfImpactIcon/ProofOfImpactIcon'

export interface ProofOfImpactIconRendererProps {
  productTitle?: string
}

const ProofOfImpactIcon = dynamic<ProofOfImpactIconProps>(
  import('../../components/ProofOfImpactIcon').then(
    (mod) => mod.ProofOfImpactIcon,
  ),
  { loading: () => <div style={{ height: 40 }} /> },
)

export const ProofOfImpactIconRenderer = (
  props: ProofOfImpactIconRendererProps,
) => {
  const { showProductProvenance, provenanceAccessToken } = useSiteConfig()

  const product = useProductPage()

  if (
    !showProductProvenance ||
    !product?.product?.description?.provenance.enabled
  ) {
    return null
  }

  return (
    <ProofOfImpactIcon
      productName={props.productTitle}
      provenanceAccessToken={provenanceAccessToken}
    />
  )
}
